export const productsDescriptions = {
  withSales: 'Unidades devueltas por este motivo, sobre las unidades vendidas de cada producto.',
  withoutSales: 'Qué parte de las unidades devueltas de este motivo corresponde a cada producto.',
}
